module.exports = __webpack_public_path__ + "img/rabbit-001.c449791.webp";